import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SpinnerClass } from "core/classes/spinner.class";
import { CreatePopup } from "core/classes/popups/popup.create.class";
import "core/classes/popups/overlay.class";
import "core/classes/form.validator.class";

$(document).ready(function() {
  if (!Abacus.PreventDefault.CreatePopup) {
    new CreatePopup();
  }
  if (!Abacus.PreventDefault.DefaultDataHandler) {
    new DefaultDataHandler();
    new DefaultFormDataHandler();
  }
  if (!Abacus.PreventDefault.Popup) {
    new InitPopup(this);
    $(document.body).on("click", ".popup", function(evt) {
      evt.preventDefault();
      $(window).trigger("abacus:loadPopupContent", [
        {
          element: this
        }
      ]);
    });
  }
});

// Need this because we are copying options and we need to reset them in the code
let PopupOptions = function() {
  return {
    classes: {
      disablePopup: "disablePopup",
      redirect: "redirect",
      popupClass: "abacusPopup",
      popupContentClass: ".abacusPopupContent",
      popupCloseClass: "closePopup",
      activatePopup: "show",
      bodyClass: "popupActivated",
      loaderClass: "loading"
    },
    closeButton: '<a href="#" tabindex="0">close popup</a>',
    popupStyles: {
      klass: "popupStyle1" // [substitute this for a number between 1-5]
    },
    timers: {
      clearContents: 400,
      showPopup: 300
    },
    messages: {
      closeAll: "abacus:closeAll",
      loadPopupContent: "abacus:loadPopupContent"
    },
    useFixed: false, // Change absolute to fixed in css popup.less to prevent margin top being added - set useFixed to true
    preventOverlayClosing: false,
    preventCloseButton: false,
    useFormValidation: true,
    preventPopupMargin: false,
    onLoad: function(context) {} // options for when popup has loaded, allows you to override the popup
  };
};

class InitPopup extends Class {
  constructor(element, options) {
    super();
    this.setOptions(PopupOptions(), options);
    this.bodyEl = $(document.body);
    this.elOptions = null;
    this.popup = $("." + this.options.classes.popupClass);
    this.popupContent = $(this.options.classes.popupContentClass);
    this.activeEl =  document.activeElement;
    this.setupEvents();
  }

  setup(elementOptions) {
    this.elOptions = elementOptions;
    this.element = $(this.elOptions.element);
    // Reset this.options to prevent other popups using previous popup classes
    $.extend(true, this.options, this.resetObject());
    // Now overwrite with custom to allow for different types of popup
    $.extend(true, this.options, elementOptions);
    this.setupPopupStyle();
    
  }

  close(closePopup) {
    var self = this;
    this.popup.removeClass(this.options.classes.activatePopup);
    if (!closePopup) Abacus.Overlay.Instance.close();
    Abacus.Overlay.Instance.removeStyle(self.options.popupStyles.klass);
    setTimeout(function() {
      if (!self.options.useFixed) self.popup.removeAttr("style");
      self.popup.attr("class", self.options.classes.popupClass);
      self.bodyEl.removeClass(self.options.classes.bodyClass);
      self.popupContent.empty();
      self.popupContent.trigger("abacus:closePopup");
      self.popupContent.off();
    }, this.options.timers.clearContents);
  }

  show() {
    var self = this;
    setTimeout(function() {
      self.bodyEl
        .removeClass(self.options.classes.bodyClass)
        .addClass(self.options.classes.bodyClass);
      self.popup
        .removeClass(self.options.classes.activatePopup)
        .addClass(self.options.classes.activatePopup);
    }, this.options.timers.showPopup);
    // Add delay before focus to gain focus to popup - strange
    setTimeout(function() {
      self.popup.focus();
    }, 350);
  }

  setupPopupStyle() {
    Abacus.Overlay.Instance.resetStyle();
    Abacus.Overlay.Instance.setStyle(this.options.popupStyles.klass);
    this.popup
      .removeClass(this.options.popupStyles.klass)
      .addClass(this.options.popupStyles.klass);
    this.element.addClass(this.options.popupStyles.klass);
  }

  setupParams(options, url) {
    var self = this;
    var requestOptions = $.extend(
      {},
      {
        url: self.element.attr("href") || self.element.attr("data-url"),
        context: self.popup.find(self.popupContent),
        headers: {
          "X-Requested-With": "Popup"
        },
        cache: false,
        beforeSend: function() {
          Abacus.Overlay.Instance.open();
          self.spinner = new SpinnerClass(self.popup.find(".sleeve"));
          self.popup.addClass(self.options.classes.loaderClass);
        }
      },
      options
    );

    return requestOptions;
  }

  setupEvents() {
    var self = this;

    $(window).on("abacus:loadPopupContent", function(
      evt,
      elementOptions,
      requestOptions
    ) {
      self.setup(elementOptions);
      $(this).on("keyup", function(e){
          if(e.which == 27){
            self.close();
          }
      })
      if ($(elementOptions.element).data("popupclass")) {
        self.options.popupStyles.klass = $(elementOptions.element).data(
          "popupclass"
        );
      }

      // need to tidy
      if (
        $(elementOptions.element)
          .closest(self.options.classes.popupContentClass)
          .parent()
          .hasClass(self.options.popupStyles.klass)
      ) {
        var options = $.extend(
          {},
          {
            beforeSend: function() {
              self.popup.attr(
                "class",
                self.options.classes.popupClass +
                  " " +
                  self.options.classes.activatePopup
              );
              $(self.options.classes.popupContentClass).addClass("loading");
            }
          },
          requestOptions
        );
        self.params = self.setupParams(options);
        self.load(self.params);
      } else {
        self.params = self.setupParams(requestOptions);
        if (!self.element.hasClass(self.options.classes.disablePopup)) {
          self.load(self.params);
        } else {
          window.location.href = self.params.url;
        }
      }

      if (self.options.preventOverlayClosing) {
        $(window).trigger("abacus:closeOverlay");
      }
    });

    $(window).on(this.options.messages.closeAll, function(e, value) {
      // triggered in overlay.class.js
      self.close(value);
    });

    $(window).on("abacus:popuploaded", function() {
      setTimeout(function() {
        $(".abacusPopupContent .closePopup").focus();
        let focusable= $('.abacusPopupContent').find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        let foc= $('.abacusPopup.attachments.show .abacusPopupContent aside').find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        self.tabindex(focusable);
        self.tabindex(foc);
    
      
      }, 500);
    });

    this.popup.on("click keyup", function(e) {
      var target = $(e.target);
      if(e.type == 'click' || e.which == 27){
      if (
        target.hasClass(self.options.classes.popupCloseClass) ||
        target.hasClass("btnClosePopup")
      ) {
        e.preventDefault();
        if (!self.options.preventCloseButton){
          self.close();
          self.element.focus();
        } 
      } else {
        self.handleData(target);
      }
    }
    });


  }

  tabindex(focusableEl){
    if(focusableEl.length){
      var firstEl = focusableEl[0];
      var lastEl = focusableEl[focusableEl.length - 1];
      console.log(firstEl, ' : ', lastEl)
      focusableEl.on('keydown', function(e) { 
         /* shift + tab */
           if ( e.shiftKey  )  {
               if (e.target === firstEl) {
                   lastEl.focus();
                   e.preventDefault();
               }
           }else if(e.keyCode === 9){ 
               if (e.target === lastEl) {
                 firstEl.focus();
                 e.preventDefault();
             }
           }  
       });
     }
  }


  resetObject() {
    var resetOptions = PopupOptions();
    return resetOptions;
  }

  handleData(target) {
    this.popup.trigger("abacus:defaultDataHandler", [this.popup, this, target]);
    if (this.options.useFormValidation)
      this.popup.trigger("abacus:defaultFormDataHandler", [
        this.popup,
        this,
        target
      ]);
  }

  positionInView() {
    if (!this.options.useFixed && !this.options.preventPopupMargin) {
      this.popup.css("margin-top", $(window).scrollTop() + "px");
    }
  }

  load(options) {
    var self = this;
    this.positionInView();
    $.ajax(options)
      .done(function(html) {
        $(this)
          .html(html)
          .prepend(self.options.closeButton);
        $(this)
          .find("a")
          .first()
          .addClass(self.options.classes.popupCloseClass);
      })
      .always(function() {
        self.popup.removeClass(self.options.classes.loaderClass);
        self.show();
        setTimeout(function() {
          self.popup.addClass(self.options.popupStyles.klass);
          self.options.onLoad(self.popup);
          $(window).trigger("abacus:InitUI", self.popup);
          self.popupContent.removeClass("loading");
          self.spinner.hide();
        }, self.options.timers.showPopup);
        self.handleData();
        $(window).trigger("abacus:popuploaded", [self.element]);
      });
  }
}

let DefaultDataHandlerOptions = function() {
  return $.extend({}, PopupOptions(), {
    ajaxOptionsClasses: {
      noAjax: "no-ajax",
      redirect: "redirect",
      close: "close"
    }
  });
};

class DefaultDataHandler extends InitPopup {
  constructor(element, options) {
    super();
    this.setOptions(DefaultDataHandlerOptions(), options);
    this.popup = $("." + this.options.classes.popupClass);
    this.setupEvents();
  }

  setupEvents() {
    var self = this;
    this.popup.on("abacus:defaultDataHandler", function(
      event,
      element,
      context,
      target
    ) {
      self.initPopup(element, context, target);
    });
  }

  initPopup(element, context, target) {
    $.extend(true, this.options, context.options);
    this.element = $(element);
    if (target !== undefined) {
      this.target = target;
      this.checkTarget();
    }
  }

  checkTarget() {
    var self = this;
    if (this.target.hasClass("redirect")) {
      this.redirect();
    }

    if ($(this.target).data("close")) {
      this.close();
    }
  }

  redirect() {
    window.location.href =
      this.target.get("href") || this.target.closest("form").attr("action");
  }

  close() {
    $(window).trigger("abacus:closeAll", [false]);
  }
}

let DefaultFormDataHandlerOptions = function() {
  return $.extend({}, DefaultDataHandlerOptions(), {
    formElement: "form",
    validationOptions: {
      // This comes from jquery validation plugin
      submitHandler: function(form) {} // override defualt form submission for ajax
    }
  });
};

class DefaultFormDataHandler extends DefaultDataHandler {
  constructor(element, options) {
    super();
    this.setOptions(DefaultFormDataHandlerOptions(), options);
    this.popup = $("." + this.options.classes.popupClass);
    this.context = $(this.options.element);
    this.bindFormEvents();
    this.setupFormActions();
    this.formValidator;
  }

  bindFormEvents() {
    var self = this;
    this.popup.on("abacus:defaultFormDataHandler", function(
      event,
      element,
      context,
      target
    ) {
      self.initForm(element, context, target);
    });
  }

  initForm(element, context, target) {
    $.extend(true, this.options, context.options);
    this.element = $(element);
    this.bindForm();
  }

  bindForm() {
    var self = this;
    var completed = this.checkFormCompleted();
    if (completed) {
      setTimeout(function() {
        $(window).trigger("abacus:closeAll", [false]);
      }, 120);
    }
  }

  checkFormCompleted() {
    return this.element
      .find(this.options.formElement)
      .hasClass("actionCompleted");
  }

  setupFormActions() {
    var self = this;

    this.popup.on("submit", this.options.formElement, function(evt) {
      if (self.popup.hasClass(self.options.popupStyles.klass)) {
        if (!$(this).hasClass(self.options.ajaxOptionsClasses.noAjax))
          evt.preventDefault();
      }
    });

    this.popup.on("click", this.options.formElement + " button", function(evt) {
      if (self.popup.hasClass(self.options.popupStyles.klass)) {
        var form = $(this).closest(self.options.formElement);
        $(window).trigger("abacus:validateForm", [
          form,
          self.options.validationOptions
        ]);
        if (form.hasClass("valid") || $(this).hasClass("cancel")) {
          var options = {
            url: form.attr("action"),
            method: form.attr("method") || "post",
            data: form.serializeArray(),
            beforeSend: function() {
              self.popup.removeClass(self.options.popupStyles.klass);
              self.spinner = new SpinnerClass(self.popup.find(".sleeve"), {
                spinnerOptions: { color: "#000" }
              });
              $(self.options.classes.popupContentClass).addClass("loading");
            }
          };
          // Add the submit button to the data request
          if ($(this).attr("name")) {
            options.data.push({
              name: $(this).attr("name"),
              value: $(this).val()
            });
          }
          if (
            $(this).attr("type") == "submit" &&
            !form.hasClass(self.options.ajaxOptionsClasses.noAjax) &&
            !$(this).hasClass(self.options.ajaxOptionsClasses.redirect)
          ) {
            evt.preventDefault();
            $(window).trigger("abacus:loadPopupContent", [
              self.options,
              options
            ]);
          } else if (!form.hasClass(self.options.ajaxOptionsClasses.noAjax)) {
            evt.preventDefault();
          }
        }
      }
    });
  }
}

export { InitPopup, DefaultDataHandler, DefaultFormDataHandler };



// WEBPACK FOOTER //
// ./Javascript/core/classes/popups/popup.class.js